import { Redirect, Route } from "react-router-dom";

const ProtectedRoute = ({ admin, children, ...rest }) => {
    return (
        <Route
            {...rest}
            render={({ location }) =>
                admin ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/verify",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
};

export default ProtectedRoute;
